// extracted by mini-css-extract-plugin
export default {"wrapper":"_1rIVO"};